<div class="dashboard display-route-container" style="height: 100%">
  <!-- [style.height.px]="height"> -->
  <div class="card timeline ui-fluid" style="height: 100%">
    <div style="display: flex; flex-wrap: wrap">
      <div class="left-column">
        <div class="pick-up-column">
          <div class="label"><i class="vme-material-icons">&#xe805;</i> Pick-up</div>
        </div>

        <div *ngIf="pickupLocation" class="location">
          <div class="pickupLocation">
            <div>{{ pickupLocation.businessName }}</div>
            <div
              *ngFor="
                let item of pickupLocation.primaryAddress
                  .replace(pickupLocation.postcode, '')
                  .split(',')
              "
            >
              {{ item }}
            </div>
            <div>{{ pickupLocation.postcode | postcode }}</div>
          </div>
        </div>

        <div style="display: flex; flex-wrap: wrap">
          <div class="earliest">
            <div class="pick-up-column">
              <h1 class="clock-label label"><i class="fa fa-clock-o"></i> Earliest</h1>
            </div>

            <div class="time">
              <div class="timeDay">
                {{ pickupEarliestDateTime | datex : 'HH:mm ddd' }}
              </div>
              <div>
                {{ pickupEarliestDateTime | datex : "DD MMM 'YY" }}
              </div>
            </div>
          </div>

          <div class="latest">
            <div class="pick-up-column">
              <h1 class="label"><i class="fa fa-clock-o"></i> Latest</h1>
            </div>

            <div class="time">
              <div class="timeDay">
                {{ pickupLatestDateTime | datex : 'HH:mm ddd' }}
              </div>
              <div>
                {{ pickupLatestDateTime | datex : "DD MMM 'YY" }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="right-column">
        <div class="drop-off-column">
          <div class="label"><i class="vme-material-icons">&#xe804;</i> Drop-off</div>
        </div>

        <div *ngIf="dropoffLocation" class="location">
          <div class="dropoffLocation">
            <div>{{ dropoffLocation.businessName }}</div>
            <div
              *ngFor="
                let item of dropoffLocation.primaryAddress
                  .replace(dropoffLocation.postcode, '')
                  .split(',')
              "
            >
              {{ item }}
            </div>
            <div>{{ dropoffLocation.postcode | postcode }}</div>
          </div>
        </div>

        <div style="display: flex; flex-wrap: wrap">
          <div class="earliest">
            <div class="drop-off-column">
              <h1 class="clock-label label"><i class="fa fa-clock-o"></i> Earliest</h1>
            </div>

            <div class="time">
              <div class="timeDay">
                {{ dropoffEarliestDateTime | datex : 'HH:mm ddd' }}
              </div>
              <div>
                {{ dropoffEarliestDateTime | datex : "DD MMM 'YY" }}
              </div>
            </div>
          </div>

          <div class="latest">
            <div class="drop-off-column">
              <h1 class="clock-label label"><i class="fa fa-clock-o"></i> Latest</h1>
            </div>

            <div class="time">
              <div class="timeDay">
                {{ dropoffLatestDateTime | datex : 'HH:mm ddd' }}
              </div>
              <div>
                {{ dropoffLatestDateTime | datex : "DD MMM 'YY" }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="timesChanged()" class="times-changed">
      <div class="obw-title">Original Booking Window</div>

      <div style="display: flex; flex-wrap: wrap">
        <div style="display: flex; flex-wrap: wrap; flex-basis: 100px; flex-grow: 1">
          <div class="earliest">
            <div class="pick-up-column">
              <h1 class="clock-label label"><i class="fa fa-clock-o"></i> Earliest</h1>
            </div>

            <div
              class="time"
              [class.unchanged]="
                selectedTask.originalPickupEarliestDateTime == pickupEarliestDateTime
              "
            >
              <div class="timeDay">
                {{ selectedTask.originalPickupEarliestDateTime | datex : 'HH:mm ddd' }}
              </div>
              <div>
                {{ selectedTask.originalPickupEarliestDateTime | datex : "DD MMM 'YY" }}
              </div>
            </div>
          </div>

          <div class="latest">
            <div class="pick-up-column">
              <h1 class="label"><i class="fa fa-clock-o"></i> Latest</h1>
            </div>

            <div
              class="time"
              [class.unchanged]="selectedTask.originalPickupLatestDateTime == pickupLatestDateTime"
            >
              <div class="timeDay">
                {{ selectedTask.originalPickupLatestDateTime | datex : 'HH:mm ddd' }}
              </div>
              <div>
                {{ selectedTask.originalPickupLatestDateTime | datex : "DD MMM 'YY" }}
              </div>
            </div>
          </div>
        </div>

        <div style="display: flex; flex-wrap: wrap; flex-basis: 100px; flex-grow: 1; width: 100%">
          <div class="earliest">
            <div class="drop-off-column">
              <h1 class="clock-label label"><i class="fa fa-clock-o"></i> Earliest</h1>
            </div>

            <div
              class="time"
              [class.unchanged]="
                selectedTask.originalDropoffEarliestDateTime == dropoffEarliestDateTime
              "
            >
              <div class="timeDay">
                {{ selectedTask.originalDropoffEarliestDateTime | datex : 'HH:mm ddd' }}
              </div>
              <div>
                {{ selectedTask.originalDropoffEarliestDateTime | datex : "DD MMM 'YY" }}
              </div>
            </div>
          </div>

          <div class="latest">
            <div class="drop-off-column">
              <h1 class="clock-label label"><i class="fa fa-clock-o"></i> Latest</h1>
            </div>

            <div
              class="time"
              [class.unchanged]="
                selectedTask.originalDropoffLatestDateTime == dropoffLatestDateTime
              "
            >
              <div class="timeDay">
                {{ selectedTask.originalDropoffLatestDateTime | datex : 'HH:mm ddd' }}
              </div>
              <div>
                {{ selectedTask.originalDropoffLatestDateTime | datex : "DD MMM 'YY" }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
